module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vgal3-a2d9ec050f3b98825376205ce5e21fd9.jpg";